import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  timeout: 60000,
});

// 요청 인터셉터
instance.interceptors.request.use(
  function (config: any) {
    const token = window.localStorage.getItem("token");
    const userID = window.localStorage.getItem("userID");
    try {
      if (token) {
        config.headers["token"] = token;
        config.headers["userId"] = userID;
      }
      return config;
    } catch (err: any) {
      console.error("[_axios.interceptors.request] config : " + err.message);
    }

    return config;
  },
  function (error: any) {
    // 요청 오류 처리
    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  async function (response: any) {
    return response;
  },
  async function (error: any) {
    const {
      response: { status },
    } = error;

    if (status === 401) {
      // empty token
      window.localStorage.clear();
      alert("세션이 만료되었습니다. 로그인 후 이용해주세요.");
      // eslint-disable-next-line no-restricted-globals
      location.href = "/login";
    }

    /*    const sendItems = new Object();
    sendItems.token = window.localStorage.getItem('token');
    const isOkTokenResult = await instance.post('/isOk', sendItems);
    if (isOkTokenResult.data != "Success") {
        window.localStorage.clear();
        alert("로그인 정보가 변경되어 로그아웃 되었습니다.");
        location.href = "/login";
    }*/

    return Promise.reject(error);
  }
);

export default instance;
